
"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import {useContext, useState} from "react";
import DefaultButton from "../buttons/DefaultButton";
import NumberInput from "../input/NumberInput";
import {useAuth} from "../../providers/authProvider";
import {ApiContext} from "../contexts/ApiContext";

function NewPresentCategoryModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
    }
) {
    const { token } = useAuth();
    const { Url } = useContext(ApiContext)
    const [name, setName] = useState('')
    const [salesPrice, setSalesPrice] = useState('')
    const [message, setMessage] = useState('')
    function addPresentCategory(event: React.FormEvent) {
        event.preventDefault()
        fetch(Url + 'admin/present-categories', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({ name,salesPrice }),
        })
            .then((res) => {
                if (res.status === 200) {
                    setName('')
                    setSalesPrice('')

                }
                return res.json()
            })
            .then((data) => {
                setMessage(data.message)
            })
    }

    return (
        <BaseModal
            show={props.openModal}
            onClose={() => props.setOpenModal(false)}
            title="Nieuw cadeau categorie toevoegen"
            footer={
                <>
                    <DefaultButton onClick={addPresentCategory} content="Toevoegen"/>
                    <DefaultButton onClick={() => props.setOpenModal(false)} content="Sluiten"/>
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Geeft naam van de categorie en de verkoopprijs op en klik op toevoegen.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <TextInput labelName="Naam"
                       inputName="name"
                       onChange={(e) => setName(e.target.value)}
                       value={name}
                       placeholder="Naam"
                       errorMessage="Vul hier de naam in, de naam moet minimaal twee letters bevatten."
                       pattern="[0-9a-zA-Z ]{2,}"
                       type="text"
            />
            <NumberInput labelName="Verkoopprijs"
                       inputName="salesPrice"
                       onChange={(e) => setSalesPrice(e.target.value)}
                       value={salesPrice}
                       placeholder="Prijs in euros"
                       errorMessage="Vul hier het bedrag in euro's in. Gebruik alleen getallen."
                       min={0}
                       max={undefined}
                       step="0.01"
            />
        </BaseModal>
    );
}
export default NewPresentCategoryModal
